<template>
  <div>
    <a-card
      :bordered="false"
      style="margin-bottom: 16px"
      :body-style="{ padding: '12px 16px 4px' }"
    >
      <!-- 统计头 -->
      <a-row :gutter="16">
        <a-col :sm="24" :lg="16" style="margin-bottom: 16px">
          <div class="module-header-fs14" style="margin-bottom: 6px">
            告警情况
          </div>

          <div class="alert-statistic-card">
            <div class="alert-item">
              <div>
                <div class="title text-overflow">当日重要告警</div>
                <div class="value">
                  {{
                    isNotUndefined(alertStatusData?.today_important_alerts)
                      ? alertStatusData.today_important_alerts
                      : '-'
                  }}
                </div>
              </div>
            </div>

            <div class="alert-item">
              <div>
                <div class="title text-overflow">当日重要告警解决率</div>
                <div class="value">
                  {{
                    isNotUndefined(
                      alertStatusData?.today_important_alerts_solved_ratio
                    )
                      ? alertStatusData.today_important_alerts_solved_ratio
                      : '-'
                  }}%
                </div>
              </div>
            </div>

            <div class="alert-item">
              <div>
                <div class="title text-overflow">历史告警</div>
                <div class="value">
                  {{
                    isNotUndefined(alertStatusData?.history_alerts_count)
                      ? alertStatusData.history_alerts_count
                      : '-'
                  }}
                </div>
              </div>
            </div>

            <div class="alert-item">
              <div>
                <div class="title text-overflow">历史告警解决率</div>
                <div class="value">
                  {{
                    isNotUndefined(alertStatusData?.history_alerts_solved_ratio)
                      ? alertStatusData.history_alerts_solved_ratio
                      : '-'
                  }}%
                </div>
              </div>
            </div>
          </div>
        </a-col>

        <a-col :sm="24" :lg="8" style="margin-bottom: 16px">
          <div class="module-header-fs14" style="margin-bottom: 6px">
            事件情况
          </div>

          <div class="alert-statistic-card event-statistic-card">
            <div class="alert-item event-item">
              <div>
                <div class="title text-overflow">当日事件</div>
                <div class="value">
                  {{
                    isNotUndefined(eventStatusData?.events_today)
                      ? eventStatusData.events_today
                      : '-'
                  }}
                </div>
              </div>
            </div>

            <div class="alert-item event-item">
              <div>
                <div class="title text-overflow">历史事件</div>
                <div class="value">
                  {{
                    isNotUndefined(eventStatusData?.events_history)
                      ? eventStatusData.events_history
                      : '-'
                  }}
                </div>
              </div>
            </div>
          </div>
        </a-col>
      </a-row>

      <!-- Top -->
      <a-row v-show="visible" :gutter="16" class="top-container">
        <a-col :md="12" :xxl="8" style="margin-bottom: 16px">
          <div class="top-item">
            <div class="module-header-fs14" style="margin-bottom: 12px">
              历史告警数Top3
            </div>
            <div class="item-card">
              <template v-if="historyAlertTop && historyAlertTop.length">
                <alert-info-top :detail="historyAlertTop"></alert-info-top>
              </template>

              <empty-component
                v-else
                :imgUrl="require('@/assets/images/info_empty.png')"
                :body-style="{
                  marginTop: '24px'
                }"
                :description-style="{
                  marginTop: '-8px',
                  marginRight: '8px'
                }"
                description="暂无数据"
              ></empty-component>
            </div>
          </div>
        </a-col>

        <a-col :md="12" :xxl="8" style="margin-bottom: 16px">
          <div class="top-item">
            <div class="module-header-fs14" style="margin-bottom: 12px">
              重要告警解决率Bottom3
            </div>
            <div class="item-card">
              <template v-if="alertSolvedBottom && alertSolvedBottom.length">
                <alert-info-top
                  unit="%"
                  :detail="alertSolvedBottom"
                ></alert-info-top>
              </template>

              <empty-component
                v-else
                :imgUrl="require('@/assets/images/info_empty.png')"
                :body-style="{
                  marginTop: '24px'
                }"
                :description-style="{
                  marginTop: '-8px',
                  marginRight: '8px'
                }"
                description="暂无数据"
              ></empty-component>
            </div>
          </div>
        </a-col>
      </a-row>

      <!-- 按钮 -->
      <div style="text-align: center">
        <a-button type="link" @click="changeDisplay">
          <a-icon v-show="!visible" type="caret-down" />
          <a-icon v-show="visible" type="caret-up" />
          <span>{{ visible ? '收起' : '展开' }}</span>
        </a-button>
      </div>
    </a-card>

    <a-card
      :bordered="false"
      style="margin-bottom: 16px"
      :body-style="{ padding: '16px' }"
    >
      <div class="table-operation-container">
        <a-space style="float: left">
          <datetime-range
            class="table-range"
            @ok="
              v => {
                datetimeRange = v
                fetch()
              }
            "
          ></datetime-range>
        </a-space>

        <a-space size="middle" style="float: right">
          <a-input-group :compact="true">
            <a-select
              v-model="searchType"
              :options="tableSearchOptions"
              style="min-width: 96px; border-right: 1px solid #fff"
            >
              <a-icon slot="suffixIcon" type="caret-down"></a-icon>
            </a-select>

            <a-input-search
              placeholder="请输入关键词"
              @search="v => handleSearch(v)"
              style="width: 160px"
            ></a-input-search>
          </a-input-group>
          <!-- 刷新 -->
          <reload-button @click="() => fetchTableData()"></reload-button>

          <!-- 导出 -->
          <export-button
            :columns="columnsAll"
            :default-selected="columnDefaultSelected"
            :export-func="exportFunc"
            :params="fetchParams"
            title="业务问题处理情况"
          ></export-button>

          <!-- 设置 -->
          <setting-button
            :columns="columnsAll"
            :default-selected="columnDefaultSelected"
            @selected="v => (columns = v)"
          ></setting-button>
        </a-space>
      </div>

      <a-table
        rowKey="service_id"
        ref="table"
        class="custom-table scroll-hidden-table"
        :data-source="tableData"
        :columns="columns"
        :loading="loading"
        :scroll="{ x: scrollX }"
        :pagination="false"
        @change="handleTableChange"
      >
        <!-- 业务名字 -->
        <template slot="service_name" slot-scope="text">
          <template v-if="text">
            <a-tooltip :title="text">
              {{ text }}
            </a-tooltip>
          </template>
          <span v-else>-</span>
        </template>
        <!-- 责任处室 -->
        <template slot="organizations" slot-scope="text">
          <template v-if="Array.isArray(text) && text.length">
            <a-tooltip
              v-for="item in text"
              :key="item.id"
              :title="item?.name || ''"
            >
              {{ item?.name || '-' }}
            </a-tooltip>
            <span>&nbsp;&nbsp;</span>
          </template>
          <span v-else>-</span>
        </template>
        <!-- 重要告警解决率 -->
        <template slot="today_critical_recovered_ratio" slot-scope="text">
          {{ text }}%
        </template>
        <!-- 历史告警解决率 -->
        <template slot="history_recovered_ratio" slot-scope="text">
          {{ text }}%
        </template>
      </a-table>

      <div style="height: 36px; margin-top: 16px">
        <a-pagination
          :current="fetchParams.page"
          :pageSize="fetchParams.page_size"
          :show-size-changer="true"
          :show-total="t => `共 ${t} 条`"
          :total="total"
          @change="
            page => {
              fetchParams.page = page
              fetchTableData()
            }
          "
          @showSizeChange="
            (_, pageSize) => {
              fetchParams.page = 1
              fetchParams.page_size = pageSize
              fetchTableData()
            }
          "
          style="float: right"
        ></a-pagination>
      </div>
    </a-card>
  </div>
</template>

<script>
import {
  getServiceAlertStatus,
  getServiceAlertEvents,
  getAlertSolvedBottom,
  getHistoryAlertTop,
  exportServiceAlertTable,
  getServiceAlert
} from '@/api/boss'
import { isNotUndefined } from '@/utils'
import AlertInfoTop from '@/components/top/AlertInfoTop.vue'
import DatetimeRange from '@/components/DatetimeRange'
import ExportButton from '@/components/button/ExportButton'
import ReloadButton from '@/components/button/ReloadButton'
import SettingButton from '@/components/button/SettingButton'
import EmptyComponent from '@/components/EmptyComponent.vue'

export default {
  name: 'ServiceAlert',
  components: {
    DatetimeRange,
    AlertInfoTop,
    ExportButton,
    ReloadButton,
    SettingButton,
    EmptyComponent
  },
  computed: {
    scrollX () {
      let sum = 0
      this.columns.forEach(column => {
        if (column?.children) {
          column.children.forEach(child => {
            sum += child.width
          })
        } else {
          sum += column.width
        }
      })
      return sum
    }
  },
  data () {
    return {
      isNotUndefined,
      fetchParams: {
        page: 1,
        page_size: 10
      },
      datetimeRange: [],
      tableSearchOptions: [{ label: '业务系统名称', value: 'service_name' }], // 表格搜索框搜索项
      searchType: 'service_name',
      loading: false, // 表格加载状态
      tableData: [], // 表格数据
      total: 0, // 表格数据总数
      exportFunc: exportServiceAlertTable,
      columnsAll: [
        {
          dataIndex: 'service_name',
          title: '业务系统名称',
          fixed: 'left',
          width: 160,
          ellipsis: true,
          scopedSlots: {
            customRender: 'service_name'
          }
        },
        {
          dataIndex: 'organizations',
          title: '责任处室',
          width: 120,
          ellipsis: true,
          scopedSlots: {
            customRender: 'organizations'
          }
        },
        {
          dataIndex: 'service_construction_manager',
          title: '运维公司对接人',
          width: 140,
          ellipsis: true,
          scopedSlots: {
            customRender: 'service_construction_manager'
          }
        },
        {
          title: '当日告警情况',
          children: [
            {
              dataIndex: 'today_critical',
              title: '重要告警',
              width: 140,
              scopedSlots: {
                customRender: 'today_critical'
              },
              sorter: true
            },
            {
              dataIndex: 'today_critical_recovered',
              title: '重要告警已恢复',
              width: 152,
              scopedSlots: {
                customRender: 'today_critical_recovered'
              },
              sorter: true
            },
            {
              dataIndex: 'today_critical_recovered_ratio',
              title: '重要告警解决率',
              width: 152,
              scopedSlots: {
                customRender: 'today_critical_recovered_ratio'
              },
              sorter: true
            },
            {
              dataIndex: 'today_critical_ticketed',
              title: '重要告警已建单',
              width: 152,
              scopedSlots: {
                customRender: 'today_critical_ticketed'
              },
              sorter: true
            }
          ]
        },
        {
          title: '历史告警情况',
          children: [
            {
              dataIndex: 'history_critical',
              title: '历史重要告警',
              width: 152,
              scopedSlots: {
                customRender: 'history_critical'
              },
              sorter: true
            },
            {
              dataIndex: 'history',
              title: '历史告警',
              width: 140,
              scopedSlots: {
                customRender: 'history'
              },
              sorter: true
            },
            {
              dataIndex: 'history_recovered',
              title: '历史告警已恢复',
              width: 152,
              scopedSlots: {
                customRender: 'history_recovered'
              },
              sorter: true
            },
            {
              dataIndex: 'history_recovered_ratio',
              title: '历史告警解决率',
              width: 152,
              scopedSlots: {
                customRender: 'history_recovered_ratio'
              },
              sorter: true
            },
            {
              dataIndex: 'history_ticketed',
              title: '历史告警已建单',
              width: 152,
              scopedSlots: {
                customRender: 'history_ticketed'
              },
              sorter: true
            }
          ]
        },
        {
          dataIndex: 'events_today',
          title: '今日事件',
          width: 140,
          ellipsis: true,
          scopedSlots: {
            customRender: 'events_today'
          },
          sorter: true
        },
        {
          dataIndex: 'events_history',
          title: '历史事件',
          width: 140,
          ellipsis: true,
          scopedSlots: {
            customRender: 'events_history'
          },
          sorter: true
        }
      ],
      columnDefaultSelected: [
        'service_name',
        'organizations',
        'service_construction_manager',
        'today_critical',
        'today_critical_recovered_ratio',
        'today_critical_ticketed',
        'history_critical',
        'history',
        'history_recovered_ratio'
      ],
      columns: [],
      visible: false, // 更多统计展示
      alertStatusData: {}, // 告警情况数据
      eventStatusData: {}, // 事件情况数据
      historyAlertTop: [], // 历史告警数Top3
      alertSolvedBottom: [] // 重要告警解决率Bottom3
    }
  },
  mounted () {
    this.columns = []
    this.columnsAll.forEach(column => {
      if (column?.children) {
        const obj = {
          title: column.title,
          children: []
        }
        column.children.forEach(child => {
          if (this.columnDefaultSelected.indexOf(child.dataIndex) !== -1) {
            obj.children.push(child)
          }
        })
        this.columns.push(obj)
      } else {
        if (this.columnDefaultSelected.indexOf(column.dataIndex) !== -1) {
          this.columns.push(column)
        }
      }
    })
    this.fetch()
  },
  methods: {
    changeDisplay () {
      this.visible = !this.visible
    },
    fetch () {
      this.fetchStatus()
      this.fetchTop()
      this.fetchTableData()
    },
    fetchStatus () {
      const params = {}
      if (this.datetimeRange.length) {
        params.start = this.datetimeRange[0].format(
          'YYYY-MM-DD HH:mm:ss'
        )
        params.end = this.datetimeRange[1].format(
          'YYYY-MM-DD HH:mm:ss'
        )
      }
      getServiceAlertStatus(params).then(res => {
        this.alertStatusData = res.data
      })
      getServiceAlertEvents(params).then(res => {
        this.eventStatusData = res.data
      })
    },
    fetchTop () {
      const params = {}
      if (this.datetimeRange.length) {
        params.start = this.datetimeRange[0].format(
          'YYYY-MM-DD HH:mm:ss'
        )
        params.end = this.datetimeRange[1].format(
          'YYYY-MM-DD HH:mm:ss'
        )
      }
      getHistoryAlertTop(params).then(res => {
        this.historyAlertTop = res.data.map(item => {
          return {
            name: item.name,
            value: item.count,
            id: item.id
          }
        })
      })
      getAlertSolvedBottom(params).then(res => {
        this.alertSolvedBottom = res.data.map(item => {
          return {
            name: item.name,
            value: item.count,
            id: item.id
          }
        })
      })
    },
    fetchTableData () {
      this.loading = true
      if (this.datetimeRange.length) {
        this.fetchParams.start = this.datetimeRange[0].format(
          'YYYY-MM-DD HH:mm:ss'
        )
        this.fetchParams.end = this.datetimeRange[1].format(
          'YYYY-MM-DD HH:mm:ss'
        )
      } else {
        delete this.fetchParams.start
        delete this.fetchParams.end
      }
      getServiceAlert(this.fetchParams)
        .then(res => {
          const data = res.data
          if (data) {
            this.total = data.total
            this.tableData = data.data
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleSearch (value) {
      if (value !== '') {
        this.fetchParams[this.searchType] = value
      } else {
        delete this.fetchParams[this.searchType]
      }
      this.fetchParams.page = 1
      this.fetchTableData()
    },
    handleTableChange (pagination, filters, sorter) {
      const { order, field } = sorter

      if (order) {
        this.fetchParams.sort_by = field
        this.fetchParams.order_by = order
        if (order === 'ascend') this.fetchParams.order_by = 'asc'
        else if (order === 'descend') this.fetchParams.order_by = 'desc'
      } else {
        delete this.fetchParams.sort_by
        delete this.fetchParams.order_by
      }
      this.fetchParams.page = 1
      this.fetchTableData()
    }
  }
}
</script>

<style lang="less" scoped>
.alert-statistic-card {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 16px;
  .alert-item {
    color: #408bf3;
    width: 100%;
    height: 84px;
    border-radius: 6px;
    overflow: hidden;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-image: url('../../../assets/images/service-monitor/alert-item.png');

    & > div {
      text-align: center;
      padding: 12px 0 0 6px;
      margin-right: 48px;
      overflow: hidden;

      .title {
        font-size: 12px;
      }

      .value {
        font-size: 30px;
        font-weight: 500;
      }
    }
  }
}
.event-statistic-card {
  .event-item {
    color: #62bb61;
    background-image: url('../../../assets/images/service-monitor/event-item.png');
  }
}

.top-container {
  margin-top: 22px;
}

.table-operation-container {
  height: 34px;
  margin-bottom: 16px;
  font-size: 16px;
  line-height: 34px;
  overflow: hidden;

  .table-range {
    height: 32px;

    & > :deep(.ant-calendar-picker-input) {
      height: 32px !important;

      .ant-calendar-range-picker-separator {
        vertical-align: baseline !important;
      }
    }
  }
}
</style>
